import Title from '@/components/ui/Title'
import Masonry, { ResponsiveMasonry } from 'react-responsive-masonry'

const FairyRing = () => {
  return (
    <div className="py-4 px-8 flex flex-col gap-8">
      <Title className="w-full text-center" text="Fairy Doorway" />
      <p className="text-3xl leading-12 md:px-16">
        This project was inspired by my fascination with traditional Irish
        mythology and stories about fairies, and incorporates elements from
        them. This project is a snippet of a story, almost a vignette, with the
        observer stumbling onto a strange clearing in the forest. Fairy rings,
        composed of a perfect circle of mushrooms, are considered magical
        gathering places that connect through space and time to fairy rings in
        other places and dimensions. This project needed a lot of meticulous
        lighting detail to pull off the warm and enchanting atmosphere, and I
        used a lot of saturated colours within the palette. Niagara systems add
        an extra magical touch to the scene. The gallery below shows the
        production of this scene, from blockout to final product in Unreal
        Engine, and the production of assets such as the mushrooms from
        modelling to texturing.
      </p>
      <div className="flex-row justify-center flex">
        <iframe
          className="aspect-video w-full md:w-[75%]"
          title="Fairy Doorway"
          src="https://www.youtube.com/embed/a8d2zwtB5q0"
        />
      </div>
      <ResponsiveMasonry columnsCountBreakPoints={{ 350: 1, 750: 2, 900: 3 }}>
        <Masonry>
          <img
            className="rounded-md shadow-lg"
            src="/portfolio/Forest3D/mushroom1.webp"
            alt="Mushroom 1"
          />
          <img
            className="rounded-md shadow-lg"
            src="/portfolio/Forest3D/mushroom2.webp"
            alt="Mushroom 2"
          />
          <img
            className="rounded-md shadow-lg"
            src="/portfolio/Forest3D/mushroom3.webp"
            alt="Mushroom 3"
          />
          <img
            className="rounded-md shadow-lg"
            src="/portfolio/Forest3D/progression.webp"
            alt="Progression"
          />
          <img
            className="rounded-md shadow-lg"
            src="/portfolio/Forest3D/scene.webp"
            alt="Scene"
          />
        </Masonry>
      </ResponsiveMasonry>
    </div>
  )
}

export default FairyRing
